import React, { Component } from 'react';
import { Form, Input, Icon, Button, message } from 'antd';
import { wrapStyle } from './style';
import { hasErrors } from '../../common/utils';
import { otpActivate, otpRevoke, getUserInfo } from '../../common/fetch';
import { bindActionCreators } from 'redux';
import { UserAction } from '../../actions';
import { connect } from 'react-redux';

class OTPForm extends Component {
	handleSubmit = async (e) => {
		const { otp_enabled } = this.props.user
		const { getFieldValue } = this.props.form;
		e.preventDefault();
		const body = {
			code: getFieldValue('otp'),
		};
		try {
			if (otp_enabled) {
				await otpRevoke(body)
			} else {
				await otpActivate(body);
				this.props.userAction.otpActivated();
			}
			const userInfo = await getUserInfo();
			this.props.userAction.readData(userInfo.data);
			message.success(`2FA Authentication ${!otp_enabled ? 'enabled' : 'disabled'} successfully`);
		} catch (error) {
			message.error(`Your authentication code to ${!otp_enabled ? 'enable' : 'disable'} 2FA was incorrect`);
		}
	};

	maxLengthCheck = (object) => {
		if (object.target.value.length > object.target.maxLength) {
			object.target.value = object.target.value.slice(0, object.target.maxLength)
		}
	};

	render() {
		const {
			getFieldDecorator,
			getFieldsError,
			getFieldError,
			isFieldTouched
		} = this.props.form;
		const { otp_enabled } = this.props.user
		const otpError = isFieldTouched('otp') && getFieldError('otp');
		return (
			<Form style={wrapStyle} onSubmit={this.handleSubmit}>
				<Form.Item validateStatus={otpError ? 'error' : ''}>
					{getFieldDecorator('otp', {
						rules: [
							{
								required: true,
								message: 'Invalid 2FA code'
							}
						]
					})(
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: '#A8A8B1' }}
								/>
							}
							type="number"
							placeholder="Enter 6-digit code"
							maxLength="6"
							onInput={this.maxLengthCheck}
						/>
					)}
				</Form.Item>
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						disabled={hasErrors(getFieldsError())}
					>
						{otp_enabled ? 'Disable 2FA' : 'Enable 2FA'}
					</Button>
				</Form.Item>
			</Form>
		);
	}
}

const WrappedOTPForm = Form.create({ name: 'otp form' })(OTPForm);

const mapStateToProps = (state) => {
	return {
		stat: state.stat,
		user: state.user,
		coin: state.coin
	};
};

const mapDispatchToProps = (dispatch) => ({
	// statAction: bindActionCreators(StatAction, dispatch),
	userAction: bindActionCreators(UserAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(WrappedOTPForm);
